import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Panel, LiveTag } from "../components/common/Panel";
import { getTxs } from "../lib/api";
import { shorten, timeAgo, fmtEth, CHAIN } from "../lib/format";

export default function Transactions() {
  const [txs, setTxs] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try { const t = await getTxs(40); if (alive) setTxs(t.transactions); } catch {}
    };
    load();
    const id = setInterval(load, 4000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <div className="fade-in" data-testid="transactions-page">
      <div className="mb-4">
        <span className="eyebrow" style={{ color: "var(--amber)" }}>Explorer</span>
        <h1 className="font-display text-[24px] font-extrabold mt-1">Transactions</h1>
      </div>
      <Panel title="Recent Transactions" action={<LiveTag />} bodyClass="overflow-auto">
        <table className="dt">
          <thead>
            <tr><th>Tx Hash</th><th>Block</th><th>Age</th><th>From</th><th>To</th><th>Value</th><th>Tx Fee</th></tr>
          </thead>
          <tbody>
            {txs.map((t) => (
              <tr key={t.hash} onClick={() => (window.location.href = `/tx/${t.hash}`)} data-testid={`txs-row-${t.hash.slice(0, 10)}`}>
                <td><Link to={`/tx/${t.hash}`} className="link-amber mono" onClick={(e) => e.stopPropagation()}>{shorten(t.hash, 10, 8)}</Link></td>
                <td><Link to={`/block/${t.blockNumber}`} className="link-amber mono" onClick={(e) => e.stopPropagation()}>#{t.blockNumber}</Link></td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{timeAgo(t.timestamp)}</td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{shorten(t.from, 6, 4)}</td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{shorten(t.to, 6, 4)}</td>
                <td className="mono text-[12px]" style={{ color: "var(--text)" }}>{fmtEth(t.valueEth, 4)} {CHAIN.symbol}</td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }} data-testid={`txs-fee-${t.hash.slice(0, 10)}`}>{t.feeBcc != null ? `${t.feeBcc.toFixed(8)} ${CHAIN.symbol}` : "—"}</td>
              </tr>
            ))}
            {txs.length === 0 && <tr><td colSpan={7} className="text-center py-10" style={{ color: "var(--muted)" }}>Waiting for transactions…</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
